<section class="ln-form-contact relative">
  <div class="w-full rounded-[33px] bg-beige bg-opacity-30 p-6 text-cafe shadow-md lg:mx-auto lg:w-[80%]">
    <h2 class="mb-4 text-xl sm:text-2xl font-semibold">
      {{'labels.completeYourPurchaseAtLunaNuevaHome' | transloco}}:
    </h2>
    <hr class="-mx-6 border-t border-rojo" />
    <div class="py-4">
      <ul class="numbered-circle-list leyend-top text-base font-normal text-cafe ">
        <li>{{'labels.fillOutTheFollowingForm' | transloco}}.</li>
        <li>{{'labels.weWillContactToConfirmPurchase' | transloco}}.</li>
        <li>
          {{'labels.makePaymentYouConfirmedTheAvailabilityOfYourPurchase' | transloco}}.
        </li>
        <li>{{'labels.supportingTheArtisansAndDesigners' | transloco}}.</li>
        <p class="ml-[25px]">{{'labels.keepCultureAlive' | transloco}}</p>
      </ul>
    </div>
    <hr class="-mx-6 border-t border-rojo" />
    <div class="py-4">
      <form [formGroup]="form" class="w-full space-y-4 lg:w-[70%]">
        <!-- Nombre -->
<!--        "{ 'border-red-500': form.get('name')?.invalid && form.get('name')?.touched }"-->
        <div class="lg:w[70%]">
          <label for="name" class="block font-medium mb-[6px]">{{'forms.placeholders.fullName' | transloco}}</label>
          <input
            id="name"
            type="text"
            formControlName="name"
            class="w-full rounded border p-2"
            [placeholder]="'forms.placeholders.fullNameExample' | transloco"
            [ngClass]="[form.get('name')?.invalid && form.get('name')?.touched ? 'border-red-500' : '', 'w-full h-[48px] border border-cafe focus:outline-verde rounded-md p-2' ]" />
          @if(form.get('name')?.touched && form.get('name')?.invalid) {
            <div class="mt-1 text-sm text-red-600">
              @if(form.get('name')?.errors?.['required']) {
                <div>{{'labels.requiredField' | transloco}}.</div>
              }
              @if(form.get('name')?.errors?.['minlength']) {
                <div>{{'messages.minFullNameLength' | transloco}}.</div>
              }

            </div>
          }
        </div>

        <!-- Teléfono -->
        <div>
          <label class="mb-[6px] block text-sm font-medium" for="phone">{{'labels.phone' | transloco}}</label>
          <div class="flex items-start gap-4">
            <!-- Bandera y código país -->
<!--            class="hide-number-arrow hide-phone-input ng-pristine w-full rounded border p-2"-->
            <input
              #phoneInput
              formControlName="phonePrefix"
              type="tel"
              (keydown)="preventTyping($event)"
              class="hide-number-arrow hide-phone-input ng-pristine w-full h-[48px] border rounded-md border-cafe focus:outline-verde p-2"
               />

            <!-- Número de teléfono -->
<!--            [ngClass]="{
                  'border-red-500': form.get('phoneNumber')?.invalid && form.get('phoneNumber')?.touched,
                }"-->
            <div class="flex flex-col">
              <input
                type="number"
                class="hide-number-arrow ng-pristine w-full rounded border p-2"
                formControlName="phoneNumber"
                [placeholder]="'forms.placeholders.phoneExample' | transloco"
                [ngClass]= "[form.get('phoneNumber')?.invalid && form.get('phoneNumber')?.touched ? 'border-red-500' : '','hide-number-arrow ng-pristine w-full h-[48px] border border-cafe focus:outline-verde rounded-md p-2' ]"
                 />
              @if (form.get('phoneNumber')?.touched && form.get('phoneNumber')?.invalid) {
                <div class="mt-1 text-sm text-red-600">{{'labels.requiredField' | transloco}}.</div>
              }
            </div>
          </div>
        </div>

        <!-- Correo -->
        <div>
          <label class="mb-[6px] block text-sm font-medium" for="email">{{'labels.email' | transloco}}</label>
<!--          class="w-full rounded-md border border-gray-300 px-4 py-2"
            [ngClass]="{ 'border-red-500': form.get('email')?.invalid && form.get('email')?.touched }"-->
          <input
            id="email"
            type="email"
            formControlName="email"
            [placeholder]="'forms.placeholders.emailExample' | transloco"
            [ngClass]= "[form.get('email')?.invalid && form.get('email')?.touched ? 'border-red-500': '', 'w-full h-[48px] border border-cafe focus:outline-verde rounded-md px-4 py-2']"
             />
          @if(form.get('email')?.touched && form.get('email')?.invalid) {
            <div class="mt-1 text-sm text-red-600">
              @if(form.get('email')?.errors?.['required']) {
                <div>{{'labels.requiredField' | transloco}}.</div>
              }
              @if (form.get('email')?.invalid) {
                <div>{{'messages.validEmail' | transloco}}.</div>
              }
            </div>

          }
        </div>

        <!-- Mensaje -->
        <div>
          <label class="mb-[6px] block text-sm font-medium" for="message">{{'labels.optionalMessage' | transloco}}</label>
<!--          class="w-full rounded-md border border-gray-300 px-4 py-2"-->
          <textarea
            rows="4"
            formControlName="message"
            maxlength="250"
            class="w-full rounded-md border border-cafe focus:outline-verde px-4 py-2"
            ></textarea>
          <div class="mt-1 flex items-start space-x-2 justify-between text-xs text-cafe">
            <p>{{'labels.provideADetailedDescription' | transloco}}.</p>
            <p class="counter">{{ contadorCaracteresMessage }}/250</p>
          </div>
        </div>

        <!-- Enviarme una copia -->
        <div class="flex items-center gap-2">
          <input id="copy" type="checkbox" formControlName="sendCopy" class="accent-verde cursor-pointer h-[18px] w-[18px]" />
          <span class="text-sm font-medium text-cafe">{{'labels.sendMeACopy' | transloco}}</span>
        </div>

        <!-- Botón -->
        <div>
          <ln-primary-button
            type="button"
            [class]="'flex w-full justify-center rounded-md bg-[#577778] py-2 text-white text-base font-semibold transition sm:hover:bg-[#305447]'"
            [label]="'buttons.send' | transloco"
            (OnClick)="onSubmit()"
            [showSpinner]="enviarButtonShowLoading()"></ln-primary-button>
        </div>
        <ln-captcha [captchaToken]="captchaToken"></ln-captcha>
      </form>
    </div>
  </div>
  @if (showSuccessfulModal()) {
    <ln-full-screen-modal [present]="showSuccessfulModal">
      <ln-successful-order-card [close]="showSuccessfulModal()" (closePressed)="closeSuccessfulModal()"
                                [tittle]="'messages.successfullyOrderRequest' | transloco"
                                [textBody]="'messages.successfulOrder' | transloco"
                                body></ln-successful-order-card>
    </ln-full-screen-modal>
  }
</section>
